<script setup lang="ts">
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import InsightSource from '@/components/home/insights/insight-source.vue';
import { useInsightSources } from '@/components/home/insights/use-insight-sources';
import { insightAxisPresentations } from '@/components/insights/insight-display';
import type { InsightAxisType, InsightTopic } from '@/types/insights';

interface Props {
  topic: InsightTopic;
  axis: InsightAxisType;
  sourceVariant?: 'white' | 'gray';
}

withDefaults(defineProps<Props>(), { sourceVariant: 'white' });

const { resolveSources } = useInsightSources();
</script>

<template>
  <div class="insight-topic-summary">
    <div class="heading">
      <div class="c-title-medium--m label">
        <DgrIcon name="summary" size="small" :keep-fill="false" />
        トピック
      </div>
      <div class="c-text-regular--s axis">
        <DgrIcon :name="insightAxisPresentations[axis].icon" size="small" />
        {{ insightAxisPresentations[axis].label }}
      </div>
    </div>
    <div class="c-text-regular--m text">
      {{ topic.text }}
      <InsightSource
        v-for="source in resolveSources(topic.sources)"
        :key="source.position"
        :position="source.position"
        :adp-document="source.document"
        :insight-source-id="source.insightSourceId"
        :location="{ source_location: 'topic', topicId: topic.id }"
        :variant="sourceVariant"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.insight-topic-summary {
  display: flex;
  flex-direction: column;

  .heading {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .label {
    display: flex;
    align-items: center;
    gap: 2px;
    color: $color-gray1000;
    fill: $color-gray1000;

    // DgrIcon のサイズプリセットに 20px が無いため上書きする。
    .icon-box {
      width: 20px;
      height: 20px;
    }
  }

  .axis {
    display: flex;
    align-items: center;
    gap: 2px;
    color: $color-gray800;
  }

  .text {
    color: $color-gray1000;
  }
}
</style>
